<div *ngIf="showLabels" class="group-item-heading">
  {{ 'HEADER.GROUP' | translate }} {{ groupItem.groupId }}
</div>
<app-subgroup-list
  [groupId]="groupItem?.groupId"
  [subgroupList]="groupItem?.subgroups"
  [departmentId]="departmentId"
></app-subgroup-list>
